<template>
  <div>
    <div class="pr-4 pb-8">
      <v-text-field
        light
        label="Title"
        v-model="item.name"
        type="text"
        required
        color="amber"
        placeholder="Name"
      ></v-text-field>

      <p class="">Age</p>
      <v-range-slider
        v-model="item.age"
        :max="100"
        :min="0"
        hide-details
        color="amber"
        track-color="grey lighten-2"
        class="text--black lighten-1"
      >
        <template v-slot:prepend>
          <p class="black--text text-caption">{{ item.age[0] }}</p>
        </template>
        <template v-slot:append>
          <p class="black--text text-caption">{{ item.age[1] }}</p>
        </template>
      </v-range-slider>

      <v-select
        light
        :items="colors"
        label="Colour code"
        :value="item.color"
        v-model.trim="item.color"
        item-text="title"
        item-value="color"
        class="mt-4"
      ></v-select>
      <v-select
        :items="local.categories"
        label="Categories"
        multiple
        v-model.trim="item.categories"
        light
      ></v-select>

      <v-expansion-panels v-model="panel" light class="">
        <v-expansion-panel>
          <v-expansion-panel-header>Notes</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-textarea
              light
              label="Description"
              color="amber"
              v-model.trim="item.body"
              :rows="2"
              :autoGrow="true"
              :hide-details="true"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>Motivations</v-expansion-panel-header>
          <v-expansion-panel-content>
            <unit-sub-items
              v-model="item.motivations"
              name="sub"
              :key="`motivations-${item.id}`"
            >
              <strong class="text--black">What are their motivations</strong>
              <p class="ma-0">Type below and press <strong>Add</strong></p>
            </unit-sub-items>
            <unit-sub-items
              v-model="item.ideal"
              name="sub"
              :key="`ideal-${item.id}`"
            >
              <strong class="text--black">What are our motivations</strong>
              <p class="ma-0">Type below and press <strong>Add</strong></p>
            </unit-sub-items></v-expansion-panel-content
          >
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>Challenges</v-expansion-panel-header>
          <v-expansion-panel-content>
            <unit-sub-items
              v-model="item.challenges"
              name="sub"
              :key="`challenges-${item.id}`"
            >
              <strong class="text--black">Potential bottlenecks</strong>
              <p class="ma-0">Type below and press <strong>Add</strong></p>
            </unit-sub-items>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>Assets</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-select
              :items="local.assets"
              label="Assets"
              multiple
              v-model.trim="item.assets"
              light
            ></v-select>
            <v-chip
              v-for="(tag, index) in item.assets"
              :key="`asset-${tag}-${index}`"
              class="mr-1 mb-1"
              >{{ tag }}</v-chip
            >
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>

    <div class="d-flex justify-end align-center pr-3">
      <v-btn @click="submit" small color="amber" class="mr-2" light
        >Change</v-btn
      >
      <v-btn @click="cancel" small color="grey" class="" light>Cancel</v-btn>
    </div>
  </div>
</template>

<script>
import { UnitSubItems } from "@/components/units";
import { itemModel } from "./model";

export default {
  name: "AudienceSystemForm",
  components: {
    UnitSubItems,
  },
  props: {
    newItem: {
      type: Object,
      default: () => {},
    },
    colors: {
      type: Array,
      default: () => [],
    },
    categories: {
      type: Array,
      default: () => [],
    },
    local: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      item: this.createItem(this.newItem),
      panel: [0, 1],
    };
  },
  methods: {
    createItem(item) {
      const proto = {};
      Object.keys(itemModel).forEach((key) => {
        proto[key] = item[key] ? item[key] : itemModel[key];
      });
      return proto;
    },
    submit() {
      this.$emit("submit", this.item);
      // this.$set(this.item, {});
    },
    cancel() {
      this.$emit("cancel", this.item);
      // this.$set(this.item, {});
    },
  },
};
</script>
